export function formatViews(views: number): string {
  if (views >= 100000000) {
    return `${(views / 100000000).toFixed(1)}亿`;
  }
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export function formatRating(rating: number): string {
  return rating.toFixed(1);
}

export function typeLabel(type: string): string {
  if (type === "movie") return "电影";
  if (type === "tv") return "电视剧";
  if (type === "variety") return "综艺";
  return "影视";
}

export function categoryPath(type: string): string {
  return `/category/${type}`;
}

export function detailPath(id: string): string {
  return `/detail/${id}`;
}